import { Trans, useTranslation } from 'react-i18next'
import { useState } from 'react'

import { FundraiserModalProps } from '../FundraiserModalProps.types'

import { AcknowledgeModal, ActionModal, Modal } from '@percent/lemonade'
import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'
import { useMutation } from '@percent/partner-dashboard/common/hooks'

export function CloseFundriaserModal({ isOpen, onClose, refresh, fundraiser }: Readonly<FundraiserModalProps>) {
  const { t } = useTranslation()
  const { fundraisersService } = useServices()
  const [isSuccess, setIsSuccess] = useState<boolean>(false)
  const [isError, setIsError] = useState<boolean>(false)

  const [{ isLoading, data }, { apiFunc: closeFundraiser }] = useMutation(
    fundraisersService.closeFundraiser,
    () => {
      setIsSuccess(true)
      refresh()
    },
    () => {
      setIsError(true)
    }
  )

  const handleCloseFundraiser = () => {
    closeFundraiser(fundraiser.id!)
  }

  const handleCloseSuccessModal = () => {
    setIsSuccess(false)
    onClose()
  }

  const handleCloseErrorModal = () => {
    setIsError(false)
    onClose()
  }

  const handleClose = () => {
    onClose()
  }

  return (
    <>
      {!isSuccess && !isError && (
        <Modal open={isOpen} onClose={handleClose} aria-labelledby="open-close-fundraiser">
          <ActionModal
            title={t('dialog.fundraisers.close.title')}
            primaryButtonText={t('typography.yesClose')}
            secondaryButtonText={t('typography.keepFundraiser')}
            handleClose={handleClose}
            handleSubmit={handleCloseFundraiser}
            loading={!!isLoading}
            primaryBtnTestId="btn-close-fundraiser"
            disabled={!!isLoading}
          >
            <Trans
              i18nKey="dialog.fundraisers.close.description"
              components={{ b: <b /> }}
              values={{ fundraiserTitle: fundraiser.title }}
            />
          </ActionModal>
        </Modal>
      )}
      {data && (
        <Modal open={isSuccess} onClose={handleCloseSuccessModal} aria-labelledby="close-fundraiser-success">
          <AcknowledgeModal
            result="positive"
            title={t('dialog.fundraisers.close.success.title')}
            description={t('dialog.fundraisers.close.success.description')}
            buttonText={t('button.close')}
            handleClose={handleCloseSuccessModal}
            buttonTestId="success-modal-btn"
          />
        </Modal>
      )}
      <Modal open={isError} onClose={handleCloseErrorModal} aria-labelledby="close-fundraiser-error">
        <AcknowledgeModal
          result="negative"
          title={t('dialog.fundraisers.close.error.title')}
          description={t('dialog.error.description')}
          buttonText={t('button.close')}
          handleClose={handleCloseErrorModal}
          buttonTestId="error-modal-btn"
        />
      </Modal>
    </>
  )
}
